var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,0A3.1,3.1,0,0,0,0,3,3.1,3.1,0,0,0,.9,5.2L19.8,24,.9,42.8a3.1,3.1,0,0,0-.1,4.3,3.1,3.1,0,0,0,4.3.1c0-.1,0-.1.1-.1L24,28.2,42.8,47.1a3,3,0,1,0,4.4-4.2c-.1,0-.1,0-.1-.1L28.2,24,47.1,5.2a3,3,0,0,0,0-4.3A2.9,2.9,0,0,0,44.9,0a3.3,3.3,0,0,0-2.1.9L24,19.8,5.2.9A3.1,3.1,0,0,0,3,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3d0e6e1d.svg";
export { ForwardRef as ReactComponent };